import { createSlice } from '@reduxjs/toolkit';

import type { ContactContext } from '@core/context/types';

export const contactSlice = createSlice({
  name: 'contact',
  initialState: {}, // set our initial state with default values
  reducers: {
    // Update value for list id
    setContactIdentifiers: (state: ContactContext, action) => {
      const { contactId, transactionId } = action.payload;
      state.contactId = contactId;
      state.transactionId = transactionId;
    },
  },
});

// Actions
export const { setContactIdentifiers } = contactSlice.actions;
// Selectors

export const selectContactId = (state) => state.contact.contactId;

// Reducer
export default contactSlice.reducer;
